import hatsApi from '@/services/hatsApi'

export default {
  getGenders (params) {
    let filter = params || ''
    return hatsApi().get('/system/gender/?filter=' + filter)
  }
}



// WEBPACK FOOTER //
// ./src/services/hatsApi/Gender.js